import DataTable from 'react-data-table-component'

import Pagination from '../Pagination'

import '../../assets/css/Datatable.css'
const DataTableList = (props) => {
    const CustomPagination = () => {
        return (
            <Pagination
                totalPage={props?.paginationTotalRows} // Adjust according to your rows per page
                currentPage={props?.currentPage}
                setCurrentPage={props?.onChangePage}
            />
        );
    }
    return (
        <div>
            <DataTable
                columns={props?.columns}
                data={props?.data}
                selectableRows={props?.selectableRows}
                onSelectedRowsChange={props?.onSelectedRowsChange}
                progressPending={props?.progressPending}
                progressComponent={props?.progressComponent}
                pagination={props?.paginationTotalRows > 1 ? true : false}
                paginationComponent={CustomPagination}
                paginationServer
                onChangePage={props?.onChangePage}
                paginationTotalRows={props?.paginationTotalRows}
                customStyles={props?.customStyles}
                selectableRowsComponent={props?.selectableRowsComponent}
                selectAllRows={props?.selectAllRows}
                onSelectAllChange={props?.onSelectAllChange}
                sortIcon={true}
                noDataComponent={props?.noDataComponent}
                clearSelectedRows={props?.clearSelectedRows}
                selectableRowDisabled={props?.selectableRowDisabled}
            />
        </div>
    )
}

export default DataTableList
